import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-add_light",
  "use": "icon-add_light-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"icon-add_light\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M-3-3h28v28H-3z\" /><path fill=\"#FFF\" d=\"M9.833 9.833V.5h2.334v9.333H21.5v2.334h-9.333V21.5H9.833v-9.333H.5V9.833z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol